/**
 * Mock promotions seed.
 *
 * Promotions are a new, still-loosely-defined concept (see meeting notes). This
 * seed exists so the Promotions admin page renders a realistic list while the
 * backend contract and the editor design are worked out. Shape is intentionally
 * minimal: just what the catalog list needs (image / title / type / status).
 */
const promotions = [
  {
    id: "promo-summer-bogo",
    name: "Summer Conference BOGO",
    type: "BOGO",
    status: "published",
    image: null,
    summary: "Buy one conference title, get one free.",
    startsAt: "2026-06-01T00:00:00.000Z",
    endsAt: "2026-08-31T23:59:59.000Z",
    updatedAt: "2026-06-28T14:00:00.000Z",
  },
  {
    id: "promo-platinum-early",
    name: "Platinum Early Access 15% Off",
    type: "Percent Off",
    status: "scheduled",
    image: null,
    summary: "15% off for Platinum and above during early access.",
    startsAt: "2026-07-15T00:00:00.000Z",
    endsAt: "2026-07-22T23:59:59.000Z",
    updatedAt: "2026-06-27T09:30:00.000Z",
  },
  {
    id: "promo-free-ship-50",
    name: "Free Shipping Over $50",
    type: "Free Shipping",
    status: "published",
    image: null,
    summary: "Free standard shipping on orders over $50.",
    startsAt: "2026-05-01T00:00:00.000Z",
    endsAt: null,
    updatedAt: "2026-06-20T16:45:00.000Z",
  },
  {
    id: "promo-family-bundle",
    name: "Family Reunion Bundle",
    type: "Bundle",
    status: "in_review",
    image: null,
    summary: "Curated Family Reunion bundle at a discount.",
    startsAt: "2026-07-01T00:00:00.000Z",
    endsAt: "2026-07-31T23:59:59.000Z",
    updatedAt: "2026-06-29T11:10:00.000Z",
  },
  {
    id: "promo-gwp-tumbler",
    name: "Free Tumbler With Purchase",
    type: "Gift With Purchase",
    status: "scheduled",
    image: null,
    summary: "Free branded tumbler on orders over $75.",
    startsAt: "2026-08-01T00:00:00.000Z",
    endsAt: "2026-08-15T23:59:59.000Z",
    updatedAt: "2026-06-26T08:00:00.000Z",
  },
  {
    id: "promo-flash-audio",
    name: "Audio Flash Sale",
    type: "Flash Sale",
    status: "published",
    image: null,
    summary: "24-hour flash sale on select audio titles.",
    startsAt: "2026-06-30T00:00:00.000Z",
    endsAt: "2026-07-01T00:00:00.000Z",
    updatedAt: "2026-06-29T07:15:00.000Z",
  },
  {
    id: "promo-spring-clearance",
    name: "Spring Clearance 25% Off",
    type: "Percent Off",
    status: "archived",
    image: null,
    summary: "Past clearance event, kept for reference.",
    startsAt: "2026-03-01T00:00:00.000Z",
    endsAt: "2026-03-31T23:59:59.000Z",
    updatedAt: "2026-04-02T10:00:00.000Z",
  },
  {
    id: "promo-leadership-bundle",
    name: "Leadership Summit Bundle",
    type: "Bundle",
    status: "in_review",
    image: null,
    summary: "Leadership Summit starter bundle.",
    startsAt: "2026-09-01T00:00:00.000Z",
    endsAt: "2026-09-30T23:59:59.000Z",
    updatedAt: "2026-06-25T13:20:00.000Z",
  },
  {
    id: "promo-holiday-bogo",
    name: "Holiday BOGO",
    type: "BOGO",
    status: "archived",
    image: null,
    summary: "Last year's holiday BOGO, archived.",
    startsAt: "2025-12-01T00:00:00.000Z",
    endsAt: "2025-12-31T23:59:59.000Z",
    updatedAt: "2026-01-03T12:00:00.000Z",
  },
];

export default promotions;
